import { useEffect } from 'react';
import { useInfiniteQuery } from 'react-query';

import { projectsApi } from 'src/Services/API';

const useFetchProjectComments = (projectId: string, assetId: string) => {
  const query = useInfiniteQuery({
    queryKey: ['fetch-project-comments', projectId],
    queryFn: async ({ pageParam = undefined }) => {
      return (await projectsApi.projectsControllerListComments(projectId, assetId, 20, pageParam))
        .data;
    },
    getNextPageParam: lastPage => lastPage.endCursor ?? undefined,

    // Cache the comments for a minute so we are up to date
    cacheTime: 1 * 60 * 1000,
    staleTime: 1 * 60 * 1000,
  });

  // Fetch all the pages automatically
  useEffect(() => {
    const loadAllPages = async () => {
      if (query.hasNextPage && !query.isFetchingNextPage) {
        await query.fetchNextPage();
      }
    };

    loadAllPages();
  }, [query.hasNextPage, query.isFetchingNextPage, query.fetchNextPage]);

  return query;
};

export default useFetchProjectComments;
